import React, { useEffect, useState } from "react";
import { DialogActions, IconButton, InputAdornment } from "@material-ui/core";
import { FieldArray, Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Table } from "react-bootstrap";
import Illustration from "../../../../../partials/content/Illustration";
import { Badge } from "react-bootstrap";
import {
  CustomArrayTextField,
  CustomOutlinedDisabledTextField,
  CustomOutlinedDisabledNoMarginTextField,
} from "../../../../../partials/content/Forms";
import {
  FormArrayTextField,
  FormOutlinedTextField,
} from "../../../../../partials/content/Forms/FormField";
import {
  onPreventEnterSubmitting,
  setObject,
} from "../../../../../utils/utils";
import {
  cancelItemReservation,
  getItemRequestProcessDetail,
  saveProcessedItemsRequest,
} from "../../../../../services/inventory/itemReservationService";
import { Card } from "react-bootstrap";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchWarehouse from "../../warehouses/searchWarehouse";
import SearchItemStocksLocation from "../../items/searchItemStocksLocation";
import { cancelPurchaseRequest } from "../../../../../services/inventory/procurementService";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
const itemsRequestProcessSchema = yup.object().shape({
  itemName: yup.string().required(),
  itemsRequestProcessed: yup.array().of(
    yup.object().shape({
      recordProcess: yup.bool(),
      processType: yup.string().when("recordProcess", {
        is: (val) => !val,
        then: yup.string().required("Process Type is required"),
      }),
      ID: yup.number(),
      warehouseID: yup.number(),
      warehouseName: yup.string().required("Warehouse Location is required"),
      batchID: yup.number().when("processType", {
        is: (value) => value === "2",
        then: yup.number().min(1, "Batch ID is required"),
      }),
      qty: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Quantity is required")
        .moreThan(0, "Quantity cannot be zero or empty")
        .when("processType", {
          is: (value) => value === "2",
          then: yup
            .number()
            .max(
              yup.ref("stockQty"),
              "Cannot reserve Quantity more than available Stock Quantity"
            ),
        })
        .default(0),
      stockQty: yup.number(),
      uomID: yup.number(),
      uomName: yup.string().required("Unit is required"),
    })
  ),
});
function ItemRequestProcessForm({
  itemRequestID = 0,
  warehouseID = 0,
  warehouseName = "",
  onCloseDialog,
  onConfirmSave,
}) {
  const [itemRequest, setItemRequest] = useState({
    itemRequestID: 0,
    salesPosID: 0,
    salesPosItemID: 0,
    salesOrderID: 0,
    salesOrderItemID: 0,
    operationCardID: 0,
    journeyID: 0,
    journeyStockID: 0,
    salesReturnID: 0,
    salesReturnItemID: 0,
    customerID: 0,
    statusName: "",
    itemID: 0,
    itemType: 0,
    itemTypeName: "",
    itemCode: "",
    itemName: "",
    varCode: 0,
    qty: 0,
    stockQty: 0,
    uomID: 0,
    uomName: "",
    itemsRequestProcessed: [
      {
        recordProcess: false,
        processType: "2",
        statusID: 0,
        itemRequestID: 0,
        warehouseID,
        warehouseName,
        qty: 0,
        stockQty: 0,
        batchID: 0,
        uomID: 0,
        uomName: "",
        status: "New Process",
      },
    ],
  });
  const { reload, socket } = useGlobalData();
  const { auth } = store.getState();
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedWarehouse, setSelectedWarehouse] = useState({
    ID: warehouseID,
    warehouseName,
  });
  const [openSearchWarehouse, setOpenSearchWarehouse] = useState(false);
  const [openSearchStock, setOpenSearchStock] = useState(false);

  useEffect(() => {
    setObject(socket, "lock", itemRequestID, "ITRQ", auth.user).then(
      (response) => {
        getItemRequestProcessDetailData(itemRequestID);
      }
    );
    return () => {
      setObject(socket, "release", itemRequestID, "ITRQ", auth.user);
    };
  }, [itemRequestID, reload]);
  return (
    <Formik
      initialValues={itemRequest}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={itemsRequestProcessSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        let confirmSave = false;
        for (const item of values.itemsRequestProcessed) {
          confirmSave = true;
          item.qty = parseFloat(item.qty);
        }
        if (confirmSave) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Items Request ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveProcessedItemsRequest(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  onConfirmSave();
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        dirty,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-window-maximize"></i>
                  <span>
                    <strong>Items Request Header</strong>
                  </span>
                  {values.ID > 0 ? (
                    <Badge
                      className="float-right ml-1"
                      variant={
                        values.statusID === 1
                          ? "info"
                          : values.statusID === 2
                          ? "primary"
                          : values.statusID === 3
                          ? "success"
                          : values.statusID === 9
                          ? "danger"
                          : null
                      }
                    >
                      {values.statusID !== 0
                        ? "Items Request " + values.statusName
                        : null}
                    </Badge>
                  ) : null}
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormOutlinedTextField
                        label="Item Code"
                        value={values.itemCode}
                        InputProps={{
                          startAdornment:
                            values.itemType > 0 ? (
                              <InputAdornment position="start">
                                <BootstrapTooltip title={values.itemTypeName}>
                                  <i
                                    className={
                                      values.itemType === 1
                                        ? "fas fa-boxes text-success"
                                        : values.itemType === 2
                                        ? "fas fa-tools text-primary"
                                        : values.itemType === 3
                                        ? "fas fa-building text-info"
                                        : values.itemType === 4
                                        ? "fas fa-boxes text-warning"
                                        : values.itemType === 5
                                        ? "fas fa-boxes text-danger"
                                        : null
                                    }
                                  ></i>
                                </BootstrapTooltip>
                              </InputAdornment>
                            ) : null,
                          readOnly: true,
                        }}
                      />
                      <CustomOutlinedDisabledTextField
                        label="Item Name"
                        value={values.itemName}
                      />
                      {values.salesOrderID > 0 ? (
                        <CustomOutlinedDisabledTextField
                          label="Sales Order ID"
                          value={values.salesOrderID}
                        />
                      ) : values.salesPosID > 0 ? (
                        <CustomOutlinedDisabledTextField
                          label="Sales Pos ID"
                          value={values.salesPosID}
                        />
                      ) : values.journeyID > 0 ? (
                        <CustomOutlinedDisabledTextField
                          label="Sales Journey ID"
                          value={values.journeyID}
                        />
                      ) : null}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <CustomOutlinedDisabledTextField
                        label="Request Quantity"
                        value={values.qty}
                      />
                      <CustomOutlinedDisabledTextField
                        label="Unit"
                        value={values.uomName}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Process Requested Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <FieldArray name="itemsRequestProcessed">
                        {({ push, remove }) => (
                          <React.Fragment>
                            <div className="row">
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="card">
                                  <Table borderless size="sm" responsive="xl">
                                    {values.itemsRequestProcessed &&
                                    values.itemsRequestProcessed.length > 0 ? (
                                      <thead className="text-center">
                                        <tr>
                                          <th>Status</th>
                                          <th>Warehouse</th>
                                          <th>Reserve ID</th>
                                          <th>Batch ID</th>
                                          <th>Quantity</th>
                                          <th>Stock Quantity</th>
                                          <th>Unit</th>
                                          <th>Actions</th>
                                        </tr>
                                      </thead>
                                    ) : null}
                                    <tbody>
                                      {values.itemsRequestProcessed &&
                                      values.itemsRequestProcessed.length >
                                        0 ? (
                                        values.itemsRequestProcessed.map(
                                          (item, index) => (
                                            <tr key={index}>
                                              <td>
                                                <Badge
                                                  className="my-2 text-center"
                                                  variant={
                                                    item.statusID === 1
                                                      ? "primary"
                                                      : item.statusID === 3
                                                      ? "success"
                                                      : item.statusID === 4
                                                      ? "warning"
                                                      : item.statusID === 0
                                                      ? "info"
                                                      : null
                                                  }
                                                >
                                                  {item.status}
                                                </Badge>
                                              </td>
                                              <td>
                                                {item.recordProcess ? (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequestProcessed"
                                                    index={index}
                                                    propName="warehouseName"
                                                    margin="none"
                                                    readonly
                                                  />
                                                ) : warehouseID > 0 ? (
                                                  <CustomOutlinedDisabledNoMarginTextField
                                                    value={warehouseName}
                                                  />
                                                ) : (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequestProcessed"
                                                    index={index}
                                                    propName="warehouseName"
                                                    searchButton
                                                    margin="none"
                                                    readonly
                                                    onSearchClick={() => {
                                                      setSelectedIndex(index);
                                                      setOpenSearchWarehouse(
                                                        true
                                                      );
                                                    }}
                                                  />
                                                )}
                                              </td>
                                              <td>
                                                <FormArrayTextField
                                                  arrayPropName="itemsRequestProcessed"
                                                  index={index}
                                                  propName="itemReservationID"
                                                  margin="none"
                                                  readonly
                                                />
                                              </td>
                                              <td>
                                                {!item.recordProcess &&
                                                item.processType === "2" ? (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequestProcessed"
                                                    index={index}
                                                    propName="batchID"
                                                    searchButton
                                                    margin="none"
                                                    readonly
                                                    onSearchClick={() => {
                                                      setSelectedIndex(index);
                                                      setOpenSearchStock(true);
                                                    }}
                                                  />
                                                ) : (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequestProcessed"
                                                    index={index}
                                                    propName="batchID"
                                                    margin="none"
                                                    readonly
                                                  />
                                                )}
                                              </td>
                                              <td>
                                                {!item.recordProcess ? (
                                                  <React.Fragment>
                                                    {item.batchID > 0 ? (
                                                      <FormArrayTextField
                                                        arrayPropName="itemsRequestProcessed"
                                                        index={index}
                                                        propName="qty"
                                                        quantityField
                                                        margin="none"
                                                      />
                                                    ) : (
                                                      <FormArrayTextField
                                                        arrayPropName="itemsRequestProcessed"
                                                        index={index}
                                                        propName="qty"
                                                        quantityField
                                                        margin="none"
                                                        readonly
                                                      />
                                                    )}
                                                  </React.Fragment>
                                                ) : (
                                                  <FormArrayTextField
                                                    arrayPropName="itemsRequestProcessed"
                                                    index={index}
                                                    propName="qty"
                                                    quantityField
                                                    margin="none"
                                                    readonly
                                                  />
                                                )}
                                              </td>
                                              <td>
                                                <FormArrayTextField
                                                  arrayPropName="itemsRequestProcessed"
                                                  index={index}
                                                  propName="stockQty"
                                                  quantityField
                                                  margin="none"
                                                  readonly
                                                />
                                              </td>
                                              <td>
                                                <FormArrayTextField
                                                  arrayPropName="itemsRequestProcessed"
                                                  index={index}
                                                  propName="uomName"
                                                  margin="none"
                                                  readonly
                                                />
                                              </td>
                                              <td
                                                style={{ whiteSpace: "nowrap" }}
                                                className="text-center"
                                              >
                                                {item.recordProcess ? (
                                                  <BootstrapTooltip title="Delete Processed Item">
                                                    <button
                                                      type="button"
                                                      className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                                      onClick={() => {
                                                        if (
                                                          item.itemReservationID >
                                                          0
                                                        ) {
                                                          cancelItemReservationData(
                                                            item.itemReservationID
                                                          );
                                                        } else if (
                                                          item.purchaseRequestID >
                                                          0
                                                        ) {
                                                          cancelPurchaseRequestData(
                                                            item.purchaseRequestID
                                                          );
                                                        }
                                                      }}
                                                    >
                                                      <i className="fas fa-trash-alt"></i>
                                                    </button>
                                                  </BootstrapTooltip>
                                                ) : null}
                                                {!item.recordProcess ? (
                                                  <BootstrapTooltip title="Delete Processed Item">
                                                    <button
                                                      type="button"
                                                      className="btn btn-icon btn-label-danger btn-md btn-circle mx-1"
                                                      onClick={() => {
                                                        remove(index);
                                                      }}
                                                    >
                                                      <i className="fas fa-trash-alt"></i>
                                                    </button>
                                                  </BootstrapTooltip>
                                                ) : null}
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            className="text-center py-3"
                                            colSpan="10"
                                          >
                                            <Illustration
                                              imageSource="INVIFO Inventory.png"
                                              guidance="You don't have any Processed items yet"
                                              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                              size="sm"
                                            ></Illustration>
                                          </td>
                                        </tr>
                                      )}
                                      <tr>
                                        <td
                                          className="text-center py-3"
                                          colSpan="10"
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                            onClick={() => {
                                              push({
                                                recordProcess: false,
                                                processType: "2",
                                                statusID: 0,
                                                itemRequestID: 0,
                                                warehouseID,
                                                warehouseName,
                                                qty: 0,
                                                stockQty: 0,
                                                batchID: 0,
                                                uomID: values.uomID,
                                                uomName: values.uomName,
                                                status: "New Process",
                                              });
                                            }}
                                          >
                                            <i className="fas fa-plus-circle"></i>
                                            Add Process Item
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            {dirty ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>

          <DialogLayout
            open={openSearchWarehouse}
            title="Search Warehouse"
            onCloseDialog={() => {
              setOpenSearchWarehouse(false);
            }}
            maxWIdth="md"
          >
            <SearchWarehouse
              onSelectWarehouse={(warehouse) => {
                const itemsRequestProcessed = [...values.itemsRequestProcessed];
                itemsRequestProcessed[selectedIndex].warehouseID = warehouse.ID;
                itemsRequestProcessed[selectedIndex].warehouseName =
                  warehouse.warehouseName;
                itemsRequestProcessed[selectedIndex].batchID = 0;
                itemsRequestProcessed[selectedIndex].qty = 0;
                itemsRequestProcessed[selectedIndex].stockQty = 0;
                setFieldValue(`itemsRequestProcessed`, itemsRequestProcessed);
                setSelectedWarehouse({
                  ID: warehouse.ID,
                  warehouseName: warehouse.warehouseName,
                });
                setOpenSearchWarehouse(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchWarehouse(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>

          <DialogLayout
            open={openSearchStock}
            title="Search Stock"
            onCloseDialog={() => {
              setOpenSearchStock(false);
            }}
            fullScreen={false}
          >
            <SearchItemStocksLocation
              itemID={itemRequest.itemID}
              varCode={itemRequest.varCode}
              uomID={itemRequest.uomID}
              warehouseID={selectedWarehouse.ID}
              onSelectLocation={(location) => {
                let itemFound = false;
                for (const itemProcessed of values.itemsRequestProcessed) {
                  if (
                    itemProcessed.ID === 0 &&
                    itemProcessed.warehouseID === location.locationID &&
                    itemProcessed.batchID === location.batchID
                  ) {
                    itemFound = true;
                  }
                }
                if (!itemFound) {
                  const itemsRequestProcessed = [
                    ...values.itemsRequestProcessed,
                  ];
                  itemsRequestProcessed[selectedIndex].warehouseID =
                    location.locationID;
                  itemsRequestProcessed[selectedIndex].warehouseName =
                    location.locationName;
                  itemsRequestProcessed[selectedIndex].stockQty = location.qty;
                  itemsRequestProcessed[selectedIndex].batchID =
                    location.batchID;
                  setFieldValue(`itemsRequestProcessed`, itemsRequestProcessed);
                  setOpenSearchStock(false);
                } else {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Failed",
                    text: "Item Batch already selected",
                    icon: "error",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                }
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchStock(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  function cancelPurchaseRequestData(purchaseRequestID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Purchase Request ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelPurchaseRequest(purchaseRequestID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getItemRequestProcessDetailData(itemRequestID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  function cancelItemReservationData(itemReservationID) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Items Reservation ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelItemReservation(itemReservationID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getItemRequestProcessDetailData(itemRequestID);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }

  async function getItemRequestProcessDetailData(itemRequestID) {
    const response = await getItemRequestProcessDetail(itemRequestID);
    const { data } = response.data;
    const itemRequestTmp = { ...data.itemRequest };
    if (itemRequestTmp.itemsRequestProcessed.length === 0) {
      itemRequestTmp.itemsRequestProcessed.push({
        recordProcess: false,
        processType: "2",
        statusID: 0,
        itemRequestID: 0,
        warehouseID,
        warehouseName,
        qty: 0,
        stockQty: 0,
        batchID: 0,
        uomID: itemRequestTmp.uomID,
        uomName: itemRequestTmp.uomName,
        status: "New Process",
      });
    }
    setItemRequest(itemRequestTmp);
  }
}

export default ItemRequestProcessForm;
